import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-sitekey"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "smart-captcha",
      "data-sitekey": _ctx.YANDEX_CAPTCHA_KEY
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("input", {
        type: "hidden",
        name: "smart-token",
        value: ""
      }, null, -1)
    ]), 8, _hoisted_1)
  ]))
}